import React, { useState } from "react";
import * as Icons from "Components/Icons";
import { UncontrolledTooltip } from "Components/ReactstrapSlim";
import uniqueId from "lodash/uniqueId";

interface HealthAndSafetyBadgeProps {
   container?: HTMLElement | string;
}

export const HealthAndSafetyBadge: React.FC<HealthAndSafetyBadgeProps> = ({ container }) => {
   const [id] = useState(() => uniqueId("has-"));

   return <div className="health-safety-badge" id={id}>
      <Icons.Safety />
      <UncontrolledTooltip container={container} placement="top" target={id} fade={false}>
         This location has published their health and safety policy.
      </UncontrolledTooltip >
   </div>
}

export const HealthAndSafetyFullBadge: React.FC = () => {
   const [id] = useState(() => uniqueId("has-"));

   return <div className="health-safety-full-badge" id={id}>
      <Icons.Safety />
      <span className="health-safety-full-badge-text">Health & Safety</span>
      <UncontrolledTooltip placement="top" target={id} fade={false}>
         This location has published their health and safety policy.
      </UncontrolledTooltip >
   </div>
}